import styled from 'styled-components';
import {PcBox as BasePcBox, MobileBox as BaseMobileBox} from './game-title.default.box';
import {styledByDevice} from '../../../../../themes/architecture/styled-by-device';


function common(): string {
    return `        
        font-size: 1.9em;
    `;
}

const PcBox = styled(BasePcBox)`
    ${common()};
`;

const MobileBox = styled(BaseMobileBox)`
    ${common()};
`;

export const GameTitleCasino777Box = styledByDevice(PcBox, MobileBox);